import React, { useState } from "react";
import { createPortal } from "react-dom";
import AffiliateRegister from "../pages/AffiliateRegister";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase-config";

export default function AffiliateAuthModal({ onClose, initialMode = "login" }) {
  const [mode, setMode] = useState(initialMode); // "register" | "login"
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      setSuccess("Sikeres bejelentkezés!");
      // Close modal first
      setTimeout(() => {
        if (user.email === 'grexa.zsolt@hopphomes.hu') {
          window.location.href = "/admin/dashboard";
        } else {
          window.location.href = "/affiliate/dashboard";
        }
      }, 1000);
    } catch (err) {
      let errorMessage = "Hibás email vagy jelszó.";
      if (err.code === 'auth/user-not-found') {
        errorMessage = "Ez az email cím nincs regisztrálva.";
      } else if (err.code === 'auth/wrong-password') {
        errorMessage = "Hibás jelszó.";
      } else if (err.code === 'auth/invalid-email') {
        errorMessage = "Érvénytelen email cím.";
      } else if (err.code === 'auth/too-many-requests') {
        errorMessage = "Túl sok sikertelen próbálkozás. Próbáld újra később.";
      }
      setError(errorMessage);
    }
    setLoading(false);
  };

  return createPortal(
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 z-[9999]">
      <div className="absolute inset-0" onClick={onClose} />
      <div className="relative bg-gradient-to-br from-slate-900 via-gray-900 to-black rounded-2xl shadow-2xl w-full max-w-lg border border-gray-700/50 overflow-hidden">
        {/* Header with close button */}
        <div className="flex items-center justify-between p-6 bg-gradient-to-r from-gray-800/50 to-gray-900/50 border-b border-gray-700/30">
          <h2 className="text-white text-2xl font-bold">HoppHomes Bejelentkezés</h2>
          <button
            onClick={onClose}
            className="flex items-center justify-center w-10 h-10 rounded-lg bg-gray-700/50 hover:bg-red-500/20 text-gray-300 hover:text-red-400 transition-all duration-200 group border border-gray-600/50"
            title="Bezárás"
          >
            <svg className="w-5 h-5 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        {/* Content */}
        <div className="p-8">
          {/* Tab Navigation */}
          <div className="flex bg-gray-800/50 rounded-xl p-1 mb-8">
            <button
              className={`flex-1 px-6 py-3 rounded-lg font-semibold transition-all duration-200 ${
                mode === "register" 
                  ? "bg-[#e31937] text-white shadow-lg" 
                  : "text-gray-300 hover:text-white hover:bg-gray-700/50"
              }`}
              onClick={() => window.location.href = '/affiliateregister'}
            >
              Regisztráció
            </button>
            <button
              className={`flex-1 px-6 py-3 rounded-lg font-semibold transition-all duration-200 ${
                mode === "login" 
                  ? "bg-[#e31937] text-white shadow-lg" 
                  : "text-gray-300 hover:text-white hover:bg-gray-700/50"
              }`}
              onClick={() => setMode("login")}
            >
              Bejelentkezés
            </button>
          </div>
          {mode === "register" ? (
            <AffiliateRegister onClose={onClose} />
          ) : (
            <form onSubmit={handleLogin} className="space-y-6">
              {error && (
                <div className="bg-red-500/10 border border-red-500/30 text-red-300 px-4 py-3 rounded-xl backdrop-blur-sm flex items-center space-x-3">
                  <svg className="w-5 h-5 text-red-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span>{error}</span>
                </div>
              )}
              {success && (
                <div className="bg-green-500/10 border border-green-500/30 text-green-300 px-4 py-3 rounded-xl backdrop-blur-sm flex items-center space-x-3">
                  <svg className="w-5 h-5 text-green-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span>{success}</span>
                </div>
              )}
              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-200 mb-3">
                    Email cím
                  </label>
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                    className="w-full px-4 py-4 rounded-xl bg-gray-800/50 border border-gray-600/50 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#e31937] focus:border-[#e31937] transition-all duration-200"
                    placeholder="pelda@email.com"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-200 mb-3">
                    Jelszó
                  </label>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className="w-full px-4 py-4 rounded-xl bg-gray-800/50 border border-gray-600/50 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#e31937] focus:border-[#e31937] transition-all duration-200"
                    placeholder="Adja meg jelszavát"
                  />
                </div>
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-gradient-to-r from-[#e31937] to-[#b91c3c] hover:from-[#b91c3c] hover:to-[#991b1b] disabled:from-gray-600 disabled:to-gray-700 text-white font-bold py-4 px-6 rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#e31937] focus:ring-offset-2 focus:ring-offset-gray-900 shadow-xl transform hover:scale-[1.02] disabled:hover:scale-100 flex items-center justify-center space-x-2"
              >
                {loading ? (
                  <>
                    <svg className="animate-spin w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                    <span>Bejelentkezés...</span>
                  </>
                ) : (
                  <>
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                    </svg>
                    <span>Bejelentkezés</span>
                  </>
                )}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}
